import React, { useCallback, useEffect, useState } from "react";
import { MdClear } from "react-icons/md";
import Select from "react-select";
import Swal from "sweetalert2";

import { Loading } from "../../../../components/Loading";
import ProfileEnum from "../../../../enums/ProfileEnum";
import ShippingStagesEnum from "../../../../enums/ShippingStagesEnum";
import DeliveryTypeEnum from "../../../../enums/DeliveryTypeEnum";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import store from "../../../../store/store";
import useGetWindowWidth from "../../../../utils/useGetWindowWidth";
import { CartCardShipping } from "../../components/CartCardShipping";
import styles from "./styles.module.scss";
import InputSelectAsync, { selectStyle } from "../../../../components/InputSelectAsync";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadInfiniteScroll from "../../../../components/LoadInfiniteScroll";
import ScrollDiv from "../../components/ScrollDiv";
import DatePicker from "../../../../components/Input/DatePicker";


const PrintTags = () => {
  window.setPageTitle("Imprimir Etiquetas");

  const api = new BrComerceApiService();
  const { auth } = store.getState();
  const { user } = auth;
  const widthWindows = useGetWindowWidth();
  const isAdmin = user.profile === ProfileEnum.ADMIN.value;

  const [loading, setLoading] = useState(false);
  const [packagesFiltered, setPackagesFiltered] = useState([]);
  const [searchStringCollect, setSearchStringCollect] = useState("");
  const [packagesSelectedId, setPackagesSelectedId] = useState([]);
  const [isSelectedAllCartItems, setIsSelectedAllCartItems] = useState(true);
  const [packagesExpand, setPackagesExpand] = useState([]);
  const [shippings, setShippings] = useState([]);
  const [searchClient, setSearchClient] = useState(null);
  const [loadingInfinit, setLoadingInfinit] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [periodInitialDate, setPeriodInitialDate] = useState(null);
  const [periodFinalDate, setPeriodFinalDate] = useState(null);
  const [selectedDeliveryInFilter, setSelectedDeliveryInFilter] = useState({
    value: "",
    label: "Filtrar por postagem"
  });

  const deliveryOptions = [
    { label: "Expresso", value: DeliveryTypeEnum.SEDEX },
    { label: "Super Expresso", value: DeliveryTypeEnum.OWN_DELIVERY },
    { label: "Ultra Expresso", value: DeliveryTypeEnum.ULTRA },
    { label: "Econômico", value: DeliveryTypeEnum.PAC },
    { label: "Super Econômico", value: DeliveryTypeEnum.PACMINI },
    { label: "Entrega Hoje", value: DeliveryTypeEnum.SEDEX_HOJE },
  ];

  const handleChangeSelectFilterByDelivery = e => {
    if (!e) {
      return setSelectedDeliveryInFilter({ value: "", label: "Filtrar por postagem" });
    }
    setSelectedDeliveryInFilter(e);
  };

  const handleClearSearchFilter = () => {
    setSearchStringCollect("");
  };

  const handlePackageSelection = useCallback(
    packId => {
      const findedPackage = packagesSelectedId.find(id => id === packId);

      if (findedPackage) {
        setPackagesSelectedId(prevState =>
          prevState.filter(id => id !== packId)
        );
      } else {
        setPackagesSelectedId(prevState => [...prevState, packId]);
      }
    },
    [packagesSelectedId]
  );

  const handleToggleCheckAllCartItems = useCallback(() => {
    if (isSelectedAllCartItems) {
      setIsSelectedAllCartItems(false);
      setPackagesSelectedId([]);
      return;
    }

    setIsSelectedAllCartItems(true);
    setPackagesSelectedId(
      packagesFiltered
        .filter(
          p => p.idShippingStatus !== ShippingStagesEnum.OBJETO_CANCELADO.id
        )
        .map(s => s.id)
    );
  }, [isSelectedAllCartItems, packagesFiltered]);

  const handlePrintTags = useCallback(
    async () => {
      const data = packagesSelectedId.map(pack => {
        return pack;
      });

      try {
        setLoading(true);

        window.localStorage.setItem(
          "Brcom:Etiquetas",
          JSON.stringify(data)
        );

        const win = window.open("/etiquetas", "_blank");

        win.focus();
      } catch (e) {
        console.error(e.message);
        if (e.message === "win is null") {
          Swal.fire({
            icon: "error",
            title: "Pop-Up",
            text: "Por favor habilite os pop-ups no seu navegador."
          });
          return;
        }

        Swal.fire({
          icon: "error",
          title: "Etiquetas",
          text:
            "Houve um erro ao carregar etiquetas, tente novamente mais tarde."
        });
      } finally {
        setLoading(false);
      }
    },
    [packagesSelectedId]
  );

  const loadShippingsByUser = useCallback(async (pageParam = page, append = true) => {
    try {
      setLoadingInfinit(true);

      const hasDateFilter = periodInitialDate && periodFinalDate;

      const results = await api.makeHttpRequest({
        method: "GET",
        url: `shipping/tagsByUser`,
        params: {
          subUser: searchClient ? searchClient.sub : null,
          ...(!hasDateFilter && { page: pageParam, resultsPerPage: 20 }),
          ...(periodInitialDate && { initialDate: periodInitialDate }),
          ...(periodFinalDate && { finalDate: periodFinalDate }),
        }
      });

      if (!hasDateFilter && results?.length === 20) {
        setPage(pageParam + 1);
      } else {
        setHasMore(false);
      }

      if (append && !hasDateFilter) {
        setShippings(prevState => [...prevState, ...results]);
      } else {
        setShippings(results);
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Houve um erro ao carregar a página, tente novamente mais tarde."
      });
      console.error("Houve um erro ao carregar a página", e);
    } finally {
      setLoadingInfinit(false);
    }
  }, [api, searchClient, page, periodInitialDate, periodFinalDate]);

  useEffect(() => {
    if (!shippings) return;

    let filtered = shippings;

    if (selectedDeliveryInFilter.value) {
      filtered = filtered.filter(pack => pack.type === selectedDeliveryInFilter.value);
    }

    if (!searchStringCollect) {
      setPackagesFiltered(filtered);
      return;
    }

    if (searchStringCollect) {
      const searchString = searchStringCollect.trim();
      const packagesFilteredBySearch = filtered.filter(pack => {
        let searchableInfoInPackage = {
          sro: pack.sro,
          name: pack.name,
          orderNumber: pack.orderNumber,
          type: pack.type,
          originCepFormatted: `${pack.origin.zip.substring(0, 5)}-${pack.origin.zip.substring(5, 8)}`,
          originCep: pack.origin.zip,
          destinationCepFormatted: `${pack.destination.zip.substring(0, 5)}-${pack.destination.zip.substring(5, 8)}`,
          destinationCep: pack.destination.zip,
          originName: pack.origin.name,
          destinationName: pack.destination.name
        };

        return Object.values(searchableInfoInPackage)
          .filter(value => !!value)
          .some(
            packageInfo =>
              !!packageInfo &&
              String(packageInfo)
                .toLowerCase()
                .includes(searchString.toLowerCase())
          );
      });
      setPackagesFiltered(packagesFilteredBySearch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippings, searchStringCollect, selectedDeliveryInFilter.value]);

  useEffect(() => {
    if (!searchClient) return;

    setPage(1);
    setHasMore(true);
    setPackagesFiltered([]);
    setPackagesSelectedId([]);
    setIsSelectedAllCartItems(false);
    loadShippingsByUser(1, false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchClient, periodInitialDate, periodFinalDate]);

  const handlePackageExpand = useCallback(
    pack => {
      const find = packagesExpand.find(p => p.id === pack.id);
      if (find) {
        const newPacks = packagesExpand.filter(p => p.id !== pack.id);
        setPackagesExpand([...newPacks]);
      } else {
        packagesExpand.push(pack);
        setPackagesExpand([...packagesExpand]);
      }
    },
    [packagesExpand]
  );

  const handleOnChangeCalendarPeriod = e => {
    const inicio = e.dateStart ? e.dateStart?.split("/") :
      e.length ? e[0]?.split("/") : undefined;
    const fim = e.dateEnd ? e.dateEnd?.split("/") :
      e.length ? e[1]?.split("/") : undefined;

    if (inicio && fim) {
      setPeriodInitialDate(
        new Date(Number(inicio[2]), Number(inicio[1] - 1), Number(inicio[0]))
      );
      setPeriodFinalDate(
        new Date(Number(fim[2]), Number(fim[1] - 1), Number(fim[0]))
      );
    }
  };

  const handleClearPeriodFilter = () => {
    setPeriodInitialDate("");
    setPeriodFinalDate("");
  };

  return (
    <>
      <Loading loading={loading} />
      <div className={styles.main}>
        <div className={styles.container}>
          <div className={styles.title}>
            <h2>
              <strong>Objetos para impressão</strong>
            </h2>
          </div>
          <div className={styles.actionButtons}>

            <div className={styles.inputClient}>
              <InputSelectAsync
                search={searchClient}
                setSearch={setSearchClient}
              />
            </div >

            <div className={styles.input}>
              <input
                type="text"
                name="search"
                placeholder="Filtrar resultados"
                onChange={e => setSearchStringCollect(e.target.value)}
                value={searchStringCollect}
              />

              {!!searchStringCollect?.length && (
                <MdClear
                  style={{ cursor: "pointer" }}
                  onClick={handleClearSearchFilter}
                />
              )}
            </div>
            <div className={`${styles.input} ${styles.selectPicker}`}>
              <DatePicker
                className={`datePickerConfig ${styles.inputPicker}`}
                change={handleOnChangeCalendarPeriod}
                placeholder="Filtrar por período"
                showClearButton={!!periodInitialDate && !!periodFinalDate}
                onClearFields={handleClearPeriodFilter}
                dateStart={periodInitialDate}
                dateFinal={periodFinalDate}
                range
              />
            </div>
            <div className={styles.inputDelivery}>
              <Select
                onChange={handleChangeSelectFilterByDelivery}
                isClearable={selectedDeliveryInFilter.value}
                options={deliveryOptions}
                value={selectedDeliveryInFilter}
                placeholder="Filtrar por postagem"
                styles={selectStyle}
              />
            </div>
          </div>

          <div className={`${styles.buttonsContainer}`}>
            <button
              type="button"
              onClick={handleToggleCheckAllCartItems}
              disabled={!shippings.length}
            >
              {(isSelectedAllCartItems &&
                packagesSelectedId.length) ||
                packagesSelectedId.length ===
                packagesFiltered.length ?
                "Desmarcar todos" : "Marcar todos"}
            </button>
            <button
              onClick={() => handlePrintTags(shippings)}
              disabled={!packagesSelectedId.length}
            >
              Imprimir
            </button>
          </div>


          <ScrollDiv data={shippings}>
            <InfiniteScroll
              dataLength={shippings.length}
              next={loadShippingsByUser}
              hasMore={hasMore}
              loader={loadingInfinit && !loading && <LoadInfiniteScroll />}
              scrollableTarget="scrollDiv"
              className={styles.infiniteScroll}
            >{
                packagesFiltered?.map(pack => (
                  <div className={styles.collectWrapper}>
                    <CartCardShipping
                      widthWindows={widthWindows}
                      key={pack.id}
                      shipping={pack}
                      isSelected={packagesSelectedId.find(id => pack.id === id)}
                      isExpand={packagesExpand.find(
                        packExpand => pack.id === packExpand.id
                      )}
                      onClick={() => handlePackageSelection(pack.id)}
                      onExpand={() => handlePackageExpand(pack)}
                      setLoading={setLoading}
                      isAdmin={isAdmin}
                      linkTracking
                    />
                  </div>
                ))
              }
            </InfiniteScroll>
          </ScrollDiv>
          {!shippings.length && !loadingInfinit && (
            <div className={styles.collectWrapper}>
              <div className={styles.notFoundOrEmptyContainer}>
                <p>
                  {!!shippings?.length && !!searchStringCollect
                    ? "Não foram encontradas envios para essa pesquisa."
                    : "Selecione o cliente."}
                </p>
              </div>
            </div>
          )}
        </div>
      </div >
    </>
  );
};

export { PrintTags };
